<template>
  <div>
    <search-bar
      @search="onSearch"
      name="pr_code,pr_detail,pr_orispeccode"
      placeholder="输入产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div class="weui-cell weui-cell_access" v-for="item in items" :key="item.ma_Code">
        <div class="weui-cell__bd">
          <p>{{item.ma_Code}}</p>
          <p class="list-item-muted">{{item.pr_code}} {{item.pr_detail}}</p>
          <p class="list-item-muted" v-if="item.pr_orispeccode">{{item.pr_orispeccode}}</p>
          <p class="list-item-muted" v-if="item.pr_spec">{{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ma_vendname}}</p>
          <p class="list-item-muted">
            <span v-format="'#,##0.#'">{{item.ma_madeqty}}</span>&nbsp;/&nbsp;
            <span v-format="'#,##0.#'">{{item.ma_qty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <span
            class="list-item-status"
            :class="{'warning':item.madestatus!='已完工'}"
          >{{item.madestatus}}</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/report/productionProgressOS",
      filters: [
        {
          type: "date",
          name: "make.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "ma_tasktype='OS'"
            },
            {
              value: 1,
              label: "未审核",
              condition: "ma_tasktype='OS' and ma_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "ma_tasktype='OS' and ma_statuscode='AUDITED'"
            },
            {
              value: 3,
              label: "已结案",
              condition: "ma_tasktype='OS' AND ma_statuscode='FINISH'"
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.doSearch()
  }
};
</script>